<template>
    <transition name="fade-scale">
        <div class="brt-message" v-if="visible" :style="getStyles">
            <span>{{ content }}</span>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Message",

        data () {
            return {
                visible: false,

                timeout: 3,

                content: '',

                styles: {
                    bottom: 150
                }
            }
        },

        computed: {
            getStyles () {

                if(this.styles.top) {
                    return `top: ${this.styles.top}px`;
                }
                else if(this.styles.bottom) {
                    return `bottom: ${this.styles.bottom}px`;
                }
            }
        },

        mounted () {
            setTimeout( () => this.visible = false, this.timeout * 1000);
        }

    }
</script>

<style lang="less">
    @import "../../styles/comm.less";
    @import "../../styles/transition.less";
    .brt-message {
        text-align: center;
        position: fixed;
        left: @spacingNumber * 1.5;
        right: @spacingNumber * 1.5;
        z-index: 90000;
        font-size: 0;

        > span {
            display: inline-block;
            word-break: break-all;
            border-radius: @50px;
            padding: @20px @spacingNumber;
            font-size: @26px;
            color: #FFFFFF;
            background-color: rgba(0, 0, 0, 0.6);
        }
    }
</style>
